import { NgModule } from '@angular/core';
import { CustomFormModule } from '@shared/custom-form/custom-form.module';
import { CustomerRoutingModule } from './customer-routing.module';
import { SharedModule } from '@shared/shared.module';
import { CustomerListComponent } from './pages/customer-list/customer-list.component';
import { IconsModule } from '@shared/icons/icons.module';

@NgModule({
    declarations: [CustomerListComponent],
    imports: [CustomFormModule, CustomerRoutingModule, SharedModule, IconsModule]
})
export class CustomerModule {}
